/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import transform from 'lodash/transform';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Object helper
 */
export const objectHelper = {
  /**
   * Deep difference between two objects
   *
   * @param {object} object Object compared
   * @param {object} base   Object to compare with
   *
   * @return {object} The object contains all differences
   */
  difference(object, base) {
    return transform(object, (result, value, key) => {
      if (!isEqual(value, base[key])) {
        result[key] = (isObject(value) && isObject(base[key])) ? this.difference(value, base[key]) : value;
      }
    });
  },

  /**
   * Parse a JSON string, or return the value when already an object.
   * Returns defaultValue when input is null/undefined, or when JSON.parse fails.
   *
   * @param {any} input
   * @param {any} [defaultValue=null]
   *
   * @returns {any}
   */
  parse(input, defaultValue) {
    if (defaultValue === undefined) {
      defaultValue = null;
    }

    if (input == null) {
      return defaultValue;
    }

    if (typeof input !== 'string') {
      return input;
    }

    try {
      return JSON.parse(input);
    } catch (error) {
      return defaultValue;
    }
  },

  /**
   * True when two objects match after omitting the given keys (deep compare).
   *
   * @param {Object} a
   * @param {Object} b
   * @param {string[]} [keys]
   *
   * @returns {boolean}
   */
  isEqualOmitting(a, b, keys = []) {
    if (!a || !b) {
      return false;
    }

    return isEqual(omit(cloneDeep(a), keys), omit(cloneDeep(b), keys));
  }
};
